module.exports = function() {
  return new Worker("/" + "parcel-html-transpiler.44afacb7.worker.js");
};